import { render, staticRenderFns } from "./WhatsAppSettings.vue?vue&type=template&id=4a204452&scoped=true&"
import script from "./WhatsAppSettings.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a204452",
  null
  
)

export default component.exports